import classNames from 'classnames';
import { Link as LinkPrimitive } from 'react-router-dom';

import styles from './Link.module.scss';
import { LinkProps } from './Link.types';

export const Link = ({
  size,
  selected,
  error,
  disabled,
  className,
  draggable,
  to,
  onClick,
  onKeyUp,
  ...props
}: LinkProps) => (
  <LinkPrimitive
    className={classNames(styles.link, className, size && styles[size], {
      [styles.error]: error,
      [styles.disabled]: disabled,
      [styles.selected]: selected,
    })}
    tabIndex={disabled ? undefined : 0}
    to={!disabled && to ? to : 'javascript:void(0)'}
    draggable={!disabled && !!to ? draggable : false}
    onKeyUp={event => {
      if (event.key === 'Enter') {
        if (disabled) return event.preventDefault();
        if (!to) event.preventDefault();
        onKeyUp?.(event);
      }
    }}
    onClick={event => {
      if (disabled) return event.preventDefault();
      if (!to) event.preventDefault();
      onClick?.(event);
    }}
    data-icon-size={
      size
        ? {
            xxsmall: 'xsmall',
            xsmall: 'xsmall',
            small: 'medium',
            medium: 'medium',
            large: 'medium',
          }[size]
        : undefined
    }
    {...props}
  />
);
